export const SET_ACCOUNT = "SET_ACCOUNT";
export const SET_CURRENT_NETWORK = "SET_CURRENT_NETWORK";
export const SET_ETHERSCAN_NETWORK = "SET_ETHERSCAN_NETWORK";
export const SET_WEB3 = "SET_WEB3";
export const SET_TOKEN_ADDRESSES = "SET_TOKEN_ADDRESSES";
export const SET_NUMBER_OF_FUNDS = "SET_NUMBER_OF_FUNDS"
export const SET_NUMBER_USER_FUNDS = "SET_NUMBER_USER_FUNDS";